import CircleProgress from './CircleProgress';

export default CircleProgress;
